export default "__VITE_ASSET__03364e66__"